import React from 'react';
import { withStyles } from 'material-ui/styles';

const styles = theme => ({
  img: {
    width: '100%',
  },
  link : {
    textDecoration: 'none',
    color: 'black',
  },
});


class ImagePiece extends React.Component {
  render() {
    const classes = this.props.classes;
    const data = this.props.data;
    const body = 
      <img className={classes.img} alt={data.alt} src={data.src} title={data.name}/>
    return (
      body
    );
  }

}

export default withStyles(styles)(ImagePiece);


// WEBPACK FOOTER //
// ./src/search/display/image_piece.js